type FaceTecCustomization = Record<string, Record<string, unknown>>;

type FaceTecSDKWithCustomization = {
  FaceTecCustomization: new () => FaceTecCustomization;
  FaceTecCancelButtonLocation: { TopRight: unknown };
  setCustomization(customization: FaceTecCustomization): void;
};

const FONT_FAMILY = 'Roboto,Albert Sans,"Helvetica Neue",Arial,sans-serif';
const PRIMARY_COLOR = '#0D47A1';
const BACKGROUND_COLOR = '#37474F';

function buildCustomization(FaceTecSDK: FaceTecSDKWithCustomization): FaceTecCustomization {
  const customization = new FaceTecSDK.FaceTecCustomization();

  customization.initialLoadingAnimationCustomization.messageTextColor = '#fff';

  customization.overlayCustomization.backgroundColor = BACKGROUND_COLOR;
  customization.overlayCustomization.showBrandingImage = false;
  customization.overlayCustomization.brandingImage = '';

  customization.guidanceCustomization.backgroundColors = BACKGROUND_COLOR;
  customization.guidanceCustomization.headerFont = FONT_FAMILY;
  customization.guidanceCustomization.readyScreenSubtextTextColor = '#fff';
  customization.guidanceCustomization.readyScreenHeaderTextColor = '#fff';
  customization.guidanceCustomization.subtextFont = FONT_FAMILY;
  customization.guidanceCustomization.buttonFont = FONT_FAMILY;
  customization.guidanceCustomization.buttonTextNormalColor = '#fff';
  customization.guidanceCustomization.buttonBackgroundNormalColor = PRIMARY_COLOR;
  customization.guidanceCustomization.buttonTextHighlightColor = '#fff';
  customization.guidanceCustomization.buttonBackgroundHighlightColor = 'rgba(13, 71, 161, 0.5)';
  customization.guidanceCustomization.buttonTextDisabledColor = 'rgba(0, 0, 0, 0.25)';
  customization.guidanceCustomization.buttonBackgroundDisabledColor = 'rgba(0, 0, 0, 0.04)';
  customization.guidanceCustomization.buttonBorderColor = 'transparent';
  customization.guidanceCustomization.buttonBorderWidth = '0';
  customization.guidanceCustomization.buttonCornerRadius = '0';
  customization.guidanceCustomization.readyScreenOvalFillColor = 'transparent';
  customization.guidanceCustomization.readyScreenTextBackgroundColor = '#fff';
  customization.guidanceCustomization.readyScreenTextBackgroundCornerRadius = '0';
  customization.guidanceCustomization.retryScreenImageBorderWidth = '2px';
  customization.guidanceCustomization.retryScreenImageCornerRadius = '0';
  customization.guidanceCustomization.retryScreenOvalStrokeColor = PRIMARY_COLOR;
  customization.guidanceCustomization.retryScreenSubtextTextColor = '#fff';
  customization.guidanceCustomization.retryScreenHeaderTextColor = '#fff';
  customization.guidanceCustomization.retryScreenSlideshowImages = [];
  customization.guidanceCustomization.retryScreenSlideshowInterval = '1500ms';
  customization.guidanceCustomization.enableRetryScreenSlideshowShuffle = true;

  customization.resultScreenCustomization.backgroundColors = '#fff';
  customization.resultScreenCustomization.foregroundColor = PRIMARY_COLOR;
  customization.resultScreenCustomization.messageFont = FONT_FAMILY;
  customization.resultScreenCustomization.activityIndicatorColor = PRIMARY_COLOR;
  customization.resultScreenCustomization.resultAnimationBackgroundColor = PRIMARY_COLOR;
  customization.resultScreenCustomization.resultAnimationForegroundColor = '#fff';
  customization.resultScreenCustomization.resultAnimationSuccessBackgroundImage = '';
  customization.resultScreenCustomization.resultAnimationUnsuccessBackgroundImage = '';
  customization.resultScreenCustomization.showUploadProgressBar = false;
  customization.resultScreenCustomization.uploadProgressTrackColor = 'rgba(0, 0, 0, 0.2)';
  customization.resultScreenCustomization.uploadProgressFillColor = PRIMARY_COLOR;

  customization.feedbackCustomization.shadow = 'none';
  customization.feedbackCustomization.cornerRadius = '0';
  customization.feedbackCustomization.backgroundColor = '#fff';
  customization.feedbackCustomization.textColor = PRIMARY_COLOR;
  customization.feedbackCustomization.textFont = FONT_FAMILY;

  customization.frameCustomization.backgroundColor = 'transparent';
  customization.frameCustomization.borderColor = 'transparent';
  customization.frameCustomization.borderWidth = '0';
  customization.frameCustomization.borderCornerRadius = '0';
  customization.frameCustomization.shadow = 'none';

  customization.cancelButtonCustomization.location = FaceTecSDK.FaceTecCancelButtonLocation.TopRight;
  customization.cancelButtonCustomization.hideForCameraPermissions = false;

  return customization;
}

export function applyFaceTecTheme(FaceTecSDK: FaceTecSDKWithCustomization): void {
  const customization = buildCustomization(FaceTecSDK);
  FaceTecSDK.setCustomization(customization);
}
